import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import {
  ButtonGroup,
  ButtonToolbar,
  Col,
  Icon,
  IconButton,
  Loader,
  Message,
  Panel,
  Row,
  Table,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import CenterAddBankAccountForm from './CenterAddBankAccountForm'
import CenterAddBankAccountView from './CenterAddBankAccountView'
import {
  deleteAttachmentGrantee,
  getBankAccount,
  getDownloadAttachmentGrantee,
  getStampedDocument,
  getStampedDocumentUrl,
  saveBankAccount,
  saveStampedDocument,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import ButtonPanel from '../../widgets/ButtonPanel'
import notification from '../../utils/notification'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { downloadGranteeFileById } from '../../redux/actions/granteeProperty'
import { cloneDeep, isEmpty } from 'lodash-es'

export default function StampedDocumentWidget(props) {
  const { showCommandButton, isSave } = props
  const { Column, HeaderCell, Cell } = Table
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  // const [formSchema, setFormSchema] = useState(props.schema)
  const [formSchema, setFormSchema] = useState()
  const [showSuccess, setShowSuccess] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [fileId, setFileId] = useState(false)
  const [rowDataItem, setRowDataItem] = useState(false)
  const [disabledForm, setDisabledForm] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [delFilesImage, setDelFilesImage] = useState([])

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [accessToken, setAccessToken] = useState()

  useEffect(() => {
    const _accessToken = localStorage.getItem('access_token')
    setAccessToken(_accessToken)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getStampedDocument(projectId)
      // console.log('_schema gggg', _schema.model)
      setFormSchema(_schema.model)
      setDisabledForm(_schema?.model?.isCanEdit ?? false)
      setAttachFiles(_schema?.model?.data ?? [])
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onPreview = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await getDownloadAttachmentGrantee(projectId, fileObj.id, true)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.fileName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'แสดงเอกสารไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await getDownloadAttachmentGrantee(projectId, fileObj.id, true)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.fileName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (rowData) => {
    console.log('rowData => ', rowData)

    let oldAttachFiles = cloneDeep(attachFiles || [])

    // console.log('oldAttachFiles => ', oldAttachFiles)

    if (rowData.isRequired) {
      oldAttachFiles = oldAttachFiles.map((item) => {
        if (item.id === rowData.id) {
          return {
            ...item,
            fileName: '',
            fileLabel: '',
            filePath: '',
          }
        }

        return item
      })

      let delArr = cloneDeep(delFilesImage || [])
      delArr.push(rowData.id)
      setDelFilesImage(delArr)
    } else {
      // ลบเฉพาะ row ที่ id ตรงกับ rowData.id
      oldAttachFiles = oldAttachFiles.filter((item) => item.id !== rowData.id)
    }

    // เก็บ id ไว้สำหรับส่งไปลบที่ Backend
    if (rowData.id) {
      setDelFilesImage((prev) => [...(prev || []), rowData.id])
    }

    console.log('newAttachFiles => ', oldAttachFiles)

    setAttachFiles(oldAttachFiles)
  }
  // startLoading()
  // setIsDeleteError(false)
  // try {
  //   const status = await deleteAttachmentGrantee(projectId, rowData.id)
  //   console.log('status => ', status)
  //   if (status === 200) {
  //     handleGetSchema()
  //   } else {
  //     setIsDeleteError('ไม่สำเร็จ')
  //   }
  // } catch (e) {
  //   setIsDeleteError(e?.response?.data?.errorMessage || 'ไม่สำเร็จ')
  // }
  // doneLoading()
  // }

  const setRowData = (id, newData) => {
    // console.log('set row data => ', id, newData)
    setAttachFiles((state) => {
      return state.map((item) => {
        if (item.numberOfSequence === id) {
          return {
            ...item,
            ...newData,
          }
        }
        // if (item.id === id) {
        //   return {
        //     ...item,
        //     ...newData,
        //   }
        // }
        return item
      })
    })
  }

  const onUploadSuccess = (response) => {
    // console.log('onUploadSuccess => ', response)

    setFormSchema(response.model)
    setDisabledForm(response?.model?.isCanEdit ?? false)
    setAttachFiles(response?.model?.data ?? [])
  }

  const handleAddfileEtc = () => {
    let oldAttachFiles = cloneDeep(attachFiles || [])

    // console.log('oldAttachFiles => ', oldAttachFiles)

    const etcFile = {
      id: null,
      projectContractId: null,
      masterContractFileId: '33350',
      masterContractFileName: 'เอกสารอื่นๆ',
      isChecked: false,
      numberOfSequence: (oldAttachFiles?.length || 0) + 1,
      attachmentTypeId: 0,
      fileName: null,
      fileLabel: null,
      filePath: null,
      createBy: null,
      createDate: null,
      isDeleted: true,
      isRequired: false,
    }

    oldAttachFiles.push(etcFile)

    setAttachFiles(oldAttachFiles)
  }

  const checkFilesRequired = (dataLists) => {
    console.log('checkFilesRequired => ', dataLists)

    if (!Array.isArray(dataLists) || dataLists.length === 0) {
      notification.open('error', {
        title: 'ไม่พบรายการไฟล์เอกสาร',
        duration: 5000,
      })
      return false
    }

    const missingDocument = dataLists.find((item) => {
      if (item.isRequired !== true) return false

      // มีไฟล์เดิมในระบบ
      const hasExistingFile = item.filePath != null && item.filePath !== ''

      // มีไฟล์ใหม่ที่เพิ่งเลือก
      const hasNewFile = Array.isArray(item.localFileList) && item.localFileList.length > 0

      return !hasExistingFile && !hasNewFile
    })

    if (missingDocument) {
      notification.open('error', {
        title: `กรุณาแนบไฟล์ ${missingDocument.masterContractFileName}`,
        duration: 5000,
      })

      return false
    }

    return true
  }
  // const checkFilesRequired = (dataLists) => {
  //   console.log('checkFilesRequired => ', dataLists)

  //   if (!Array.isArray(dataLists) || dataLists.length === 0) {
  //     notification.open('error', {
  //       title: 'ไม่พบรายการไฟล์เอกสาร',
  //       duration: 5000,
  //     })
  //     return false
  //   }

  //   const document = dataLists.find((item) => item.masterContractFileId === '33301')

  //   if (!document) {
  //     notification.open('error', {
  //       title: 'ไม่พบเอกสารตีตราสาร',
  //       duration: 5000,
  //     })
  //     return false
  //   }

  //   // ไฟล์เดิมที่บันทึกอยู่ในระบบ
  //   const hasExistingFile =
  //     document.id != null && document.filePath != null && document.filePath !== ''

  //   // ไฟล์ใหม่ที่ user เพิ่งเลือก
  //   const hasNewFile = Array.isArray(document.localFileList) && document.localFileList.length > 0

  //   if (!hasExistingFile && !hasNewFile) {
  //     notification.open('error', {
  //       title: 'กรุณาแนบเอกสารตีตราสาร',
  //       duration: 5000,
  //     })
  //     return false
  //   }

  //   return true
  // }

  const handleSaveFiles = async () => {
    // console.log('handleSaveFiles ')
    // console.log('row data attachFiles => ', attachFiles)

    const chkFile = checkFilesRequired(attachFiles)

    // return false

    if (!chkFile) {
      return false
    }

    setIsLoading(true)
    startLoading()

    try {
      const formData = new FormData()

      attachFiles
        ?.filter((item) => item?.localFileList?.length > 0)
        .forEach((item, index) => {
          formData.append(`Attachment[${index}].Id`, item?.attId || '')
          formData.append(`Attachment[${index}].ProjectVersionId`, projectId)
          formData.append(`Attachment[${index}].FileId`, item?.attId || '')
          formData.append(`Attachment[${index}].MasterContractFileId`, item.masterContractFileId)
          formData.append(`Attachment[${index}].Files`, item.localFileList[0].blobFile)
        })

      delFilesImage &&
        delFilesImage?.forEach((element) => {
          formData.append('DeleteFileIds', element)
        })

      const resp = await saveStampedDocument(projectId, formData)
      // console.log('resp => ', resp)
      if (resp) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error handleSaveFiles ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    // data.table.map((item, index) => {
    //     formData.set(`Details[${index}].Id`, item.id)
    //     formData.set(`Details[${index}].ClosureType`, item.closureType)
    //   })

    doneLoading()
    setIsLoading(false)
  }

  if (formSchema?.disabled) {
    return false
  }

  return (
    <Panel
      shaded
      header={formSchema?.header || 'เอกสารตีตราสาร'}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      <Row style={{ marginTop: 10, width: '100%' }}>
        <Col xs={24} sm={24} md={24} lg={24} style={{ width: '100%' }}>
          <Table
            // autoHeight
            height={550}
            wordWrap
            bordered
            data={attachFiles || []}
            className="proposal-grantee-attach-files-table"
            style={{ width: '100%' }}
          >
            <Column width={90} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column minWidth={300} flexGrow={2}>
              <HeaderCell>ประเภทไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  //return validateEditFileName(rowData, index)
                  if (rowData.isRequired) {
                    return (
                      <span>
                        <span style={{ color: 'red' }}>*</span>
                        {rowData.masterContractFileName}
                      </span>
                    )
                  } else {
                    return rowData.masterContractFileName
                  }
                }}
              </Cell>
            </Column>

            <Column minWidth={100} flexGrow={1}>
              <HeaderCell>ชื่อไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  //return validateEditFileName(rowData, index)
                  if (rowData.fileLabel) {
                    return rowData.fileLabel
                  } else {
                    return (
                      rowData.isRequired &&
                      !disabledForm && <span style={{ color: 'orange' }}>**กรุณาแนบไฟล์**</span>
                    )
                  }
                }}
              </Cell>
            </Column>

            <Column width={200} align="center" fixed="right">
              <HeaderCell className="proposal-grantee-attach-files-action-header">
                แนบเอกสาร
              </HeaderCell>
              <Cell className="proposal-grantee-attach-files-action-cell">
                {(rowData, index) => {
                  if (rowData.filePath) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={isLoading}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={isLoading}
                        />

                        {/* <IconButton
                          disabled={isLoading || selectEditeIndex == index}
                          icon={<Icon icon="pencil" />}
                          onClick={(e) => handleEditFile(rowData, index)}
                        /> */}

                        {!disabledForm && (
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-cancel"
                            icon={
                              <Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />
                            }
                            onClick={(e) => handleDelete(rowData, index)}
                            disabled={!rowData.isDeleted || rowData.isChecked}
                          />
                        )}
                      </ButtonGroup>
                    )
                  } else {
                    return (
                      !disabledForm && (
                        <>
                          {rowData.isLoading && <Loader backdrop center />}
                          <Controller
                            name={`file_${index}`}
                            // name={'Files'}
                            control={control}
                            // defaultValue={!isEmpty(item.value) ? [item.value] : undefined}
                            // rules={isValidators(attachmentSchema.validators)}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                                  // draggable
                                  autoUpload={false}
                                  multiple={false}
                                  // listType="picture"
                                  // renderFileInfo={() => null}
                                  renderFileInfo={(file, fileElement) => {
                                    // console.log('ooooo => ', file, fileElement)
                                    return <div>File:</div>
                                  }}
                                  fileList={props.value || []}
                                  // style={{ marginTop: 12 }}
                                  onChange={(fileList) => {
                                    // console.log('fileList => ', fileList)
                                    setRowData(rowData.numberOfSequence, {
                                      localFileList: fileList,
                                    })
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)

                                      // setRowData(item, {
                                      //   files: undefined,
                                      // })
                                    } else {
                                      let files = []
                                      files.push(fileList[fileList.length - 1])
                                      props.onChange(files)

                                      // setRowData(item, {
                                      //   files: files,
                                      // })
                                    }
                                  }}
                                >
                                  <button className="upload__button" style={{ marginTop: 0 }}>
                                    <Icon icon="upload" size="lg" />
                                  </button>
                                </Uploader>
                              )
                            }}
                          />
                        </>
                      )
                    )
                  }
                }}
              </Cell>
            </Column>
          </Table>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} style={{ width: '100%' }}>
          <ButtonToolbar>
            {!disabledForm && (
              <>
                <IconButton
                  appearance="ghost"
                  // className="rs-btn-ghost-info"
                  style={{ marginTop: 10 }}
                  icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                  disabled={isLoading}
                  children={'เพิ่มเอกสารอื่นๆ'}
                  onClick={(e) => handleAddfileEtc()}
                />
              </>
            )}
          </ButtonToolbar>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} style={{ width: '100%' }}>
          {!!formSchema?.message && (
            <>
              <Message
                showIcon
                type={formSchema?.messageType}
                description={<span dangerouslySetInnerHTML={{ __html: formSchema?.message }} />}
                style={{ marginTop: 10, marginBottom: 5 }}
              />
            </>
          )}

          {!disabledForm && (
            <>
              <hr />

              <ButtonToolbar>
                <>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                    onClick={(e) => handleSaveFiles()}
                    disabled={isLoading}
                    children={'บันทึก'}
                  />
                </>
              </ButtonToolbar>
            </>
          )}
        </Col>
      </Row>
    </Panel>
  )
}
